import React, { useEffect, useState } from 'react'

import { makeStyles, Button } from '@material-ui/core'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'
import { RiLockPasswordLine } from 'react-icons/ri'
import { AiFillSafetyCertificate } from 'react-icons/ai'
import GeneratePasswordDialog from '../Dialog/GeneratePasswordDialog'
import { useCompanyConfig } from '../../hooks/CompanyConfiguration/useCompanyConfig'
import CertificateConfigDialog from '../Dialog/CertificateConfigDialog'
import CertificateDialog from '../Dialog/CertificateDialog'
import WeitageDialog from '../Dialog/WeitageDialogue'
const useStyles = makeStyles((theme) => ({
  input: {
    width: '50%',
  },
}))
function BusinessConfig2({ form, setForm }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [openWeitage, setWeitage] = useState(false)
  const [certificate, setCertificate] = useState(false)
  const { getLoggedInUser, loggedUser } = useCompanyConfig()
  useEffect(() => {
    getLoggedInUser()
  }, [])

  const languageOptions = [
    { value: 'English', label: 'English' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'Hindi', label: 'Hindi ' },
    { value: 'Chinese', label: 'Chinese' },
  ]
  const currencyOptions = [
    { value: 'INR', label: 'INR' },
    { value: 'DOLLAR', label: 'DOLLAR' },
    { value: 'EURO', label: 'EURO ' },
    { value: 'DINAR', label: 'DINAR' },
  ]
  const timezoneOptions = [
    { value: 'AST', label: 'AST' },
    { value: 'CET', label: 'CET' },
    { value: 'AST', label: 'AST ' },
    { value: 'GMT', label: 'GMT' },
  ]
  const monthOptions = [
    { value: 'January', label: 'January' },
    { value: 'February', label: 'February' },
    { value: 'March', label: 'March' },
    { value: 'April', label: 'April' },
    { value: 'May', label: 'May' },
    { value: 'June', label: 'June' },
    { value: 'July', label: 'July' },
    { value: 'August', label: 'August' },
    { value: 'September', label: 'September' },
    { value: 'October', label: 'October' },
    { value: 'November', label: 'November' },
    { value: 'December', label: 'December' },
  ]
  const daysOptions = [
    { value: 'Sunday', label: 'Sunday' },
    { value: 'Monday', label: 'Monday' },
    { value: 'Tuesday', label: 'Tuesday' },
    { value: 'Wednessday', label: 'Wednessday' },
    { value: 'Thursday', label: 'Thursday' },
    { value: 'Friday', label: 'Friday' },
    { value: 'Saturday', label: 'Saturday' },
    // { value: 'Saturday', label: 'Saturday' }
  ]

  const {
    language,
    currency,
    timeZone,
    financialYear,
    incentiveYears,
    workingDaysFrom,
    workingDaysTo,
    holidayFrom,
    holidayTo,
    leadDiscount,
    quoteDisclaimer,
    radius,
    graceTimePeriod,
    splashScreen,
    leadValidityNotification,
    reportingTime,
    leavingTime,
  } = form

  const settings = [
    {
      label: 'Language',
      to: [{ label: 'Language' }],
      value: language,
      name: 'language',
      options: languageOptions,

      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Currency',
      to: [{ label: 'Currency' }],
      value: currency,
      name: 'currency',
      options: currencyOptions,

      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Timezone',
      to: [{ label: 'Timezone' }],
      value: timeZone,
      name: 'timeZone',
      options: timezoneOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Financial Year Start From',
      to: [{ label: 'Financial Month' }],
      value: financialYear,
      name: 'financialYear',
      options: monthOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Working Days From',
      to: [{ label: 'From' }],
      value: workingDaysFrom,
      name: 'workingDaysFrom',
      options: daysOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Working Days To',
      to: [{ label: 'To' }],
      value: workingDaysTo,
      name: 'workingDaysTo',
      options: daysOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Reporting Time',
      value: reportingTime,
      name: 'reportingTime',

      type: 'TIME',
    },

    {
      label: 'Leaving Time',
      value: leavingTime,
      name: 'leavingTime',
      type: 'TIME',
    },
    {
      label: 'Holiday From',
      value: holidayFrom,
      name: 'holidayFrom',
      options: daysOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Holiday To',
      to: [{ label: 'To' }],
      value: holidayTo,
      name: 'holidayTo',
      options: daysOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Maximum Discount',
      input: true,
      value: leadDiscount,
      name: 'leadDiscount',
      type: 'number',
      // options: monthOptions,
    },
    {
      label: 'Eligiblity Incentive Store (Years)',
      input: true,
      value: incentiveYears,
      name: 'incentiveYears',
      type: 'number',
      // options: monthOptions,
    },
    {
      label: 'Quote Disclaimer',
      input: true,
      value: quoteDisclaimer,
      name: 'quoteDisclaimer',
      // options: monthOptions,
      grid: 12,
    },
    {
      label: 'Radius',
      input: true,
      value: radius,
      name: 'radius',
      type: 'number',
    },
    {
      label: 'Grace Time Period (Minutes)',
      input: true,
      value: graceTimePeriod,
      name: 'graceTimePeriod',
      type: 'number',
    },
    {
      label: 'Lead Expire Notification (Days)',
      value: leadValidityNotification,
      name: 'leadValidityNotification',
      type: 'number',
    },

    {
      label: 'Splash Screen',
      name: 'splashScreen',
      type: 'IMAGE',
    },
  ]
  //console.log('loggedUser : ', loggedUser)
  return (
    <>
      <GeneratePasswordDialog open={open} handleClose={() => setOpen(false)} form={form} setForm={setForm} passwordRequirement={loggedUser && loggedUser.passwordRequirement} />
      <WeitageDialog open={openWeitage} handleClose={() => setWeitage(false)} form={form} setForm={setForm} passwordRequirement={loggedUser && loggedUser.passwordRequirement} />

      {loggedUser && (
        <CertificateConfigDialog
          open={certificate}
          handleClose={() => setCertificate(false)}
          form={form}
          setForm={setForm}
          certificateConfiguration={loggedUser && loggedUser.certificateConfiguration}
        />
      )}
      {/* <CertificateDialog open={certificate} handleClose={() => setCertificate(false)} form={form} setForm={setForm} certificateConfiguration={loggedUser && loggedUser.certificateConfiguration} /> */}
      <CustomAddForm state={form} setState={setForm} data={settings} />

      <Button variant="contained" color="primary" startIcon={<RiLockPasswordLine />} style={{ marginTop: '40px' }} onClick={() => setOpen(true)}>
        {`${loggedUser && loggedUser.passwordRequirement ? 'Edit' : 'Generate'}`} Password Requirement
      </Button>
      <Button variant="contained" color="primary" startIcon={<AiFillSafetyCertificate />} style={{ marginTop: '40px', marginLeft: '10px' }} onClick={() => setCertificate(true)}>
        {`${loggedUser && loggedUser.certificateConfiguration ? 'Edit' : 'Generate'}`} Certificate Configuration
      </Button>
      <Button variant="contained" color="primary" startIcon={<AiFillSafetyCertificate />} style={{ marginTop: '40px', marginLeft: '10px' }} onClick={() => setWeitage(true)}>
        Configure Weightage
      </Button>
    </>
  )
}

export default BusinessConfig2
